// The QuickMD API returns a string error type in `ErrorCode`; depending on the caller it may
// be at the top level or nested under `response.data` (axios-style). Extracted here so the
// same shape check isn't hand-rolled per call site — the same logic also lives in
// `src/api/refreshSession.ts` (auth-refresh path, left untouched for now), and this is a
// candidate to promote into `@quickmd-llc/frontend-utils` if more apps need it.
export const readApiErrorCode = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null) return undefined
  if ('ErrorCode' in error && typeof error.ErrorCode === 'string') return error.ErrorCode
  if ('response' in error && typeof error.response === 'object' && error.response !== null) {
    const { response } = error
    if ('data' in response && typeof response.data === 'object' && response.data !== null) {
      const { data } = response
      if ('ErrorCode' in data && typeof data.ErrorCode === 'string') return data.ErrorCode
    }
  }
  return undefined
}
